import { Button, FontIcon, tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const MyAccessCodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${tokens.spacing.horizontalMedium};
  margin-bottom: ${tokens.spacing.verticalMedium};

  p {
    font-size: ${tokens.fontSize.small};
    font-weight: ${tokens.fontWeights.regular};
    line-height: ${tokens.lineHeight.medium}%;
    color: ${tokens.colors.dark5};
    margin: 0;
  }

  h4 {
    display: none;
  }

  @media only screen and (min-width: ${tokens.breakpoints.desktop}px) {
    h4 {
      display: block;
      font-size: ${tokens.fontSize.large};
      font-weight: ${tokens.fontWeights.bold};
      line-height: ${tokens.lineHeight.medium}%;
      color: ${tokens.colors.dark6};
      margin: 0 0 ${tokens.spacing.verticalSmall} 0;
    }
  }
`

export const AccessCodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${tokens.spacing.horizontalMedium};
  text-align: center;

  border-radius: ${tokens.radius.radius_20}px;
  border: solid 1px ${tokens.colors.livrosMedium};
  background-color: ${tokens.colors.livrosLight};

  p {
    font-size: ${tokens.fontSize.small};
    font-weight: ${tokens.fontWeights.bold};
    line-height: ${tokens.lineHeight.medium}%;
    color: ${tokens.colors.dark5};
    margin-top: 0;
  }

  > span {
    font-size: ${tokens.fontSize.xxxlarge};
    font-weight: ${tokens.fontWeights.bold};
    line-height: ${tokens.lineHeight.medium}%;
    color: ${tokens.colors.dark6};
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 328px;
  padding: 0;
  margin: 0 auto;
`

export const AccessCodeButton = styled(Button)`
  margin: ${tokens.spacing.verticalMedium} 0 ${tokens.spacing.verticalXsmall};
`

export const ForgotPassWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${tokens.spacing.verticalMedium};

  p {
    font-size: ${tokens.fontSize.small};
    font-weight: ${tokens.fontWeights.bold};
    line-height: ${tokens.lineHeight.medium}%;
    color: ${tokens.colors.dark5};
    text-align: center;
  }

  button {
    margin: 0 auto;
  }
`

export const Canvas = styled.canvas`
  position: absolute;
  display: none;
`

export const BlurWrapper = styled.span<{ isTokenBlured?: boolean }>`
  font-size: ${tokens.fontSize.xxxlarge};
  font-weight: ${tokens.fontWeights.bold};
  line-height: ${tokens.lineHeight.medium}%;
  color: ${tokens.colors.dark6};

  cursor: ${({ isTokenBlured }) => (isTokenBlured ? 'pointer' : 'default')};
  ${({ isTokenBlured }) => isTokenBlured && 'filter: blur(10px);'}
`

export const TokenWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${tokens.spacing.insetMedium};
`

export const ToggleBlurIcon = styled(FontIcon)`
  cursor: pointer;
`
